import { FPlusOverflownCodeIndicator } from '@festina-life/fplus'
import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Card, CardBody } from '@festina-life/ui/structure'

import type { TemplateField } from '../../types/templateModel'
import { FieldValidationsValueDetails } from '../templateFieldValidations/FieldValidationsValueDetails'
import { useFieldValidations } from '../templateFieldValidations/useFieldValidations'

type Props = {
  field: TemplateField
}

export const TemplateFieldValidationsCellContent = ({ field }: Props) => {
  const validations = useFieldValidations(field)
  const translate = useTranslate()

  const shouldRenderValidations = !!validations?.length

  return shouldRenderValidations ? (
    <div className="flex size-full flex-1">
      <Tooltip
        tip={
          <Card>
            <CardBody outerClassName="min-w-250">
              <FieldValidationsValueDetails
                validations={validations}
                fieldPath={field.path}
              />
            </CardBody>
          </Card>
        }
        className="h-full grow"
      >
        <div className="flex size-full cursor-help items-center justify-center">
          <FPlusOverflownCodeIndicator
            title={translate('templateViewer.frameColumn.validationsTooltip')}
          />
        </div>
      </Tooltip>
    </div>
  ) : null
}
